<template>
  <div>
    <div
      class="parent"
      :style="style"
      :class="[!showDetails ? 'parent-2' : '']"
    >
      <v-card @click="showCoursefun">
        <v-card-title
          class="info-title"
          :style="[cycle.State != 'ok' ? { backgroundColor: 'gray' } : '']"
        >
          <div class="text-center">
         دوره {{ cycle.cycleID }}: {{ cycle.Name }}
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cycle", "index", "showDetails"],
  methods: {
    /**
     * user click on cycle
     */
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
  computed: {
    style() {
      var res = "";
      if (this.showDetails) {
        res += "position: fixed;";
        if (this.$store.getters.isMobile) {
          res += "width: 100%;background-color: rgb(232, 232, 232) !important;";
        } else {
          res += "width: calc(100% - 300px)";
        }
      }
      return res;
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
.info-title {
  min-height: 96px;
}
</style>
